import React from 'react'
import { Typography } from '@mui/material'
import { DeleteOutlined, DragIndicatorOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { CanvasItemCard, DeleteButton, DragHandle } from './DesignerCanvasSection.styles'
import { ITextComponentInstance, textAlignmentToCss } from 'src/types/report-designer'

export interface ICanvasTextItemProps {
  item: ITextComponentInstance
  isSelected: boolean
  accentColor: string
  isDragging: boolean
  isDragOver: boolean
  onSelectItem: (id: string) => void
  onDeleteItem: (id: string) => void
  onDragStart: (e: React.DragEvent) => void
  onDragOver: (e: React.DragEvent) => void
  onDrop: (e: React.DragEvent) => void
  onDragEnd: () => void
}

export const CanvasTextItem: React.FC<ICanvasTextItemProps> = ({
  item,
  isSelected,
  accentColor,
  isDragging,
  isDragOver,
  onSelectItem,
  onDeleteItem,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
}) => {
  const { t: translate } = useTranslation(['dynamic-report'])
  const styles = item.styles

  return (
    <CanvasItemCard
      key={item.id}
      isSelected={isSelected}
      accentColor={accentColor}
      isDragging={isDragging}
      isDragOver={isDragOver}
      onClick={() => onSelectItem(item.id)}
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <DragHandle>
        <DragIndicatorOutlined fontSize="small" />
      </DragHandle>
      <Typography
        sx={{
          fontSize: styles?.fontSize ? `${styles.fontSize}px` : '0.875rem',
          color: item.content ? styles?.fontColor ?? 'text.primary' : 'text.disabled',
          fontStyle: item.content ? 'normal' : 'italic',
          fontWeight: styles?.bold ? 700 : 400,
          fontFamily: styles?.fontFamily ?? 'arial',
          textAlign: textAlignmentToCss(styles?.alignment),
          whiteSpace: 'pre-wrap',
          width: '100%',
          lineHeight: styles?.lineHeight ?? 1.4,
          letterSpacing: styles?.letterSpacing ? `${styles.letterSpacing}px` : 'normal',
        }}
      >
        {item.content || translate('text-content-placeholder', { ns: 'dynamic-report' })}
      </Typography>
      <DeleteButton
        size="small"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
          onDeleteItem(item.id)
        }}
        title={translate('delete-item', { ns: 'dynamic-report' })}
      >
        <DeleteOutlined fontSize="small" />
      </DeleteButton>
    </CanvasItemCard>
  )
}
